import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormSearchButton from '../../../library/form/components/FormSearchButton';
import FormImportLink from '../../../library/form/components/FormImportLink';
import FormPaging from '../../../library/form/components/FormPaging'
import InvItemChildGroupRow from './InvItemChildGroupRow';
import InvGroupItemDetailRow from "./InvGroupItemDetailRow";
import FormWrapper from "../../../library/form/components/FormWrapper"
import FormROValue from '../../../library/form/components/FormROValue1';
import { UiView, UiViewHeading, UiTitle, UiAction } from "../../../library/layout/Index";
import * as fn from "../../../helper/uiFunctions";

const InvItemChildGroup = (props) => {
    const { formObject, viewData } = props;
    let parentRowIndex = 0;
    if (!viewData)
        return (null)

    const renderRow = (row, index) => {
        if (fn.compareNumber(row.rowValues.parentLineId.val, 0))
        {
            parentRowIndex = parentRowIndex + 1;
            let isUOM2 = row.rowValues.uom2.val.length > 0?true:false;
            return (
                <div className="uiBoxItem" style={{ borderBottom: "1px solid #258625", marginBottom: "50px" }}>
                    <InvGroupItemDetailRow formObject={formObject} compositionKey={row.rowKey} viewData={row} rowKey={row.rowKey} key={index} index={parentRowIndex} />
                    <FormWrapper formObject={formObject} rowKey={row.rowKey} action={{ paramName: "renderGroupControl" }} >
                        <div className="uiSecContents">
                            <ul className="uiListTable">
                                <li className="uiSearchHeading" style={{ height: "25px" }}>
                                    <ul>
                                        <li className="uiColumnCenter uiColumn150" ><SarasTrans value="Batch ID" /></li>
                                        <li className="uiColumnCenter uiColumn70" ><SarasTrans value="Date" /></li>
                                        <li className="uiColumnCenter uiColumn70"><SarasTrans value="SIH" /></li>
                                        <li className="uiColumnCenter uiColumn100"><SarasTrans value="Price" /></li>
                                        <li className="uiColumnCenter uiColumn50"><SarasTrans value={row.rowValues.uom1.val} /></li>
                                        <li className="uiColumnCenter uiColumn50"><SarasTrans value={row.rowValues.uom2.val} /></li>
                                        <FormWrapper customWrapper="li" formObject={formObject} headerKey="headerRows" wrapperClass="uiColumnCenter uiColumn50" action={{ paramName: "ccLabel" }} >
                                            <SarasTrans value="CC" />
                                        </FormWrapper>
                                        <li className="uiColumnCenter uiColumn50">
                                            <SarasTrans value="Action" />
                                        </li>
                                    </ul>
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey={row.rowKey} action={{ paramName: "renderGroupTotal" }} wrapperClass="uiSearchRow">
                                    <ul>
                                        <li className="uiColumnCenter uiColumn150 uiBlue" ><SarasTrans value="Total" /></li>
                                        <li className="uiColumnCenter uiColumn70" ></li>
                                        <li className="uiColumnCenter uiColumn70"></li>
                                        <li className="uiColumnCenter uiColumn100"></li>
                                        <li className="uiColumnCenter uiColumn50 uiBlue">
                                            <FormROValue format="" formObject={formObject} rowKey={row.rowKey} action={{ paramName: "totalAlloc1" }} />
                                        </li>
                                        <li className="uiColumnCenter uiColumn50 uiBlue">
                                            <FormROValue format="" formObject={formObject} rowKey={row.rowKey} action={{ paramName: "totalAlloc2" }} />
                                        </li>
                                        <FormWrapper customWrapper="li" formObject={formObject} headerKey="headerRows" wrapperClass="uiColumnCenter uiColumn50" action={{ paramName: "ccLabel" }} >
                                            
                                        </FormWrapper>
                                        <li className="uiColumnCenter uiColumn50"></li>
                                    </ul>
                                </FormWrapper>
                                {
                                    Object.values(viewData).map((childRow, index) => (
                                        renderChildRow(childRow, index, row.rowKey, isUOM2)
                                    ))
                                }
                            </ul>
                        </div>
                    </FormWrapper>
                </div>
            )
        }
        else
            return (null)
    }

    const renderChildRow = (row, index, parenLineID, isUOM2) => {
        if(fn.compareNumber(row.rowValues.parentLineId.val, parenLineID))
            return(
                <InvItemChildGroupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} isUOM2={isUOM2} />
                // <FormLauncher viewMap={formObject.viewMap} formObject={formObject} compositionKey={row.rowKey} viewData={row} rowKey={row.rowKey} ></FormLauncher>
            )
        else{
            return(null)
        }
    }


    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Line Item' />
                </UiTitle>
                <UiAction>
                    <FormPaging formObject={formObject} />
                    <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                        action={{ actionId: "refresh",  actionParam: {} }}
                        className='uiActionIconButton' placeholder="Barcode or Item Id"
                    />
                    <FormImportLink className="uiActionIconButton" formObject={formObject} rowKey="" headerKey='importLink' action={{}} />
                </UiAction>
            </UiViewHeading>
            <div className="listItemDetails phViewContentContainer">
                {
                    Object.values(viewData).map((row, index) => (
                        renderRow(row, index)
                    ))
                }
            </div>
        </UiView>
    )
}

export default withView(InvItemChildGroup, "itemDetail", "invTrnHeader,invTrnFooter,invTrans,invTrnTracker")
